import { render, staticRenderFns } from "./gkryOrderDetail.vue?vue&type=template&id=27aabe22&scoped=true&"
import script from "./gkryOrderDetail.vue?vue&type=script&lang=js&"
export * from "./gkryOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./gkryOrderDetail.vue?vue&type=style&index=0&id=27aabe22&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aabe22",
  null
  
)

export default component.exports